import React from 'react';
import { FormikProps } from 'formik';
import { Grid } from '@mui/material';
import { useTranslation } from 'react-i18next';
import AppFormSelectWrapper from '../../../components/designe/app-form-select-wrapper';

interface ISubscriptionPlansFilterProps {
  formik: FormikProps<any>;
  filterScopeOptions: Array<{ id: string; name: string }>;
  filterPeriodOptions: Array<{ id: string; name: string }>;
}

export function SubscriptionPlansFilter(props: ISubscriptionPlansFilterProps) {
  const { formik, filterScopeOptions, filterPeriodOptions } = props;
  const { t } = useTranslation();

  return (
    <Grid container spacing={1}>
      <Grid item sm={6}>
        <AppFormSelectWrapper
          label={t('common.scope')}
          name="scope"
          options={filterScopeOptions}
          disableClear={false}
          formik={formik}
        />
      </Grid>
      <Grid item sm={6}>
        <AppFormSelectWrapper
          label={t('common.period')}
          name="period"
          options={filterPeriodOptions}
          disableClear={false}
          formik={formik}
        />
      </Grid>
    </Grid>
  );
}
